import ReactApexChart from "react-apexcharts"
import { Card, CardBody } from "reactstrap"

import { getLastTwelveMonthRanges } from "../dashboard-data"
import { getPaidTickets } from "services/tickets"
import useDashboardQuery from "../useDashboardQuery"

const DashboardOverviewChart = () => {
  const lastTwelveMonthRanges = getLastTwelveMonthRanges()

  const salesCountQuery = useDashboardQuery(
    ["dashboard-sales-count-last-12-months"],
    async () => {
      const monthlyResults = await Promise.all(
        lastTwelveMonthRanges.map(async (monthRange) => {
          const response = await getPaidTickets({
            date__gte: monthRange.startDate,
            date__lte: monthRange.endDate,
            per_page: 1,
          })

          return Number(response?.count || 0)
        })
      )

      return monthlyResults
    },
    { staleTime: 1000 * 60 * 15, keepPreviousData: true }
  )

  const salesChartLabels = lastTwelveMonthRanges.map((monthRange) => monthRange.label)
  const salesChartSeriesData = salesCountQuery.data || Array.from({ length: 12 }, () => 0)

  const salesChartSeries = [
    {
      name: "Cantidad de ventas",
      data: salesChartSeriesData,
    },
  ]

  const salesChartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: ["#2563eb"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 3 },
    fill: {
      type: "gradient",
      gradient: { shadeIntensity: 1, opacityFrom: 0.3, opacityTo: 0.05, stops: [0, 90, 100] },
    },
    grid: { borderColor: "#e5e7eb", strokeDashArray: 4 },
    xaxis: {
      categories: salesChartLabels,
      labels: { rotate: -45, style: { colors: "#64748b", fontSize: "12px" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        formatter: (value) => new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 }).format(value),
        style: { colors: "#64748b" },
      },
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 }).format(value),
      },
    },
    legend: { show: false },
  }

  return (
    <Card className="shadow-sm border-0 h-100">
      <CardBody className="p-4 d-flex flex-column h-100">
        <div className="d-flex align-items-start justify-content-between mb-4">
          <div>
            <h5 className="mb-1">Cantidad de ventas de los últimos 12 meses</h5>
          </div>
        </div>
        <div className="d-flex flex-grow-1 align-items-center justify-content-center" style={{ minHeight: 260 }}>
          <div className="w-100">
            <ReactApexChart options={salesChartOptions} series={salesChartSeries} type="area" height={280} />
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default DashboardOverviewChart